<template>
  <div class="eSearch">
    <el-row @keydown.native.enter.prevent="crud.toQuery">
      <el-col :span="24">
        <div class="formBox">
          <el-form ref="form" :inline="true" :model="formData" :label-width="labelWidth" class="formStyle">
            <div ref="formItem" class="formItem">
              <slot />
            </div>
          </el-form>
          <div class="boxOperate">
            <img v-if="showActionBtn" :src="operateImg" @click="handleCollapse">
            <el-button v-if="showDefaultBtn" size="mini" type="primary" @click="search()">{{ searchButtonText
            }}</el-button>
            <el-button v-if="showDefaultBtn" size="mini" type="info" plain @click="reSet()"
              style="margin-left:10px;">重置</el-button>
          </div>
          <!-- <div v-if="showActionBtn" class="showStatus">
            <el-button
              type="text"
              :icon="iconName"
              @click="handleCollapse"
            >{{ collapseText }}</el-button>
          </div> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    crud: {
      type: Object,
      required: true
    },
    // 设置搜索条件名字的宽
    labelWidth: {
      type: String,
      default: '100px'
    },
    // 搜索条件对象
    formData: {
      type: Object
    },
    itemWidth: {
      type: String,
      default: '170px'
    },
    showDefaultBtn: {
      type: Boolean,
      default: true
    },
    searchButtonText: {
      type: String,
      default: '查询'
    },
    defaultCollapse: {
      type: Boolean,
      default: false
    },
    resetQuery: {
      type: Function
    },
  },
  data() {
    return {
      autoShow: {
        maxHeight: 'none'
      },
      showActionBtn: false,
      isCollapse: this.defaultCollapse,
      curCol: 4
    }
  },
  computed: {
    collapseText() {
      return this.isCollapse ? '收起' : '更多'
    },
    operateImg() {
      return this.isCollapse ? require('@/assets/images/up_arrow.png') : require('@/assets/images/down_arrow.png')
    },
    iconName() {
      return this.isCollapse ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.initLayout()
    })
  },
  methods: {
    initLayout() {
      if (!this.$refs.form || !this.$refs.formItem) return
      this.formItemEls = this.$refs.formItem.querySelectorAll('.formItem .el-col')
      const formEl = this.$refs.form.$el
      this._resetLayout(this.formItemEls, formEl)
      this.addResizeListener()
    },
    addResizeListener() {
      // 监听宽口变化事件，且避免事件覆盖
      window.onresize = () => {
        if (!this.$refs.form || !this.$refs.formItem) return
        const formItemEls = this.$refs.formItem.querySelectorAll('.formItem .el-col')
        const formEl = this.$refs.form.$el
        this._resetLayout(formItemEls, formEl)
      }
    },
    /** 处理收起与展开事件 */
    handleCollapse() {
      this.isCollapse = !this.isCollapse
      this.resetDisplay()

      this.$emit('handleCollapse')
    },

    /** 重置隐藏元素 */
    resetDisplay() {
      if (!this.$refs.formItem) return
      Array.from(this.$refs.formItem.querySelectorAll('.formItem .el-col')).map((node, index) => {
        if (index >= this.curCol * 1 && !this.isCollapse) {
          node.style.display = 'none'
        } else {
          node.style.display = 'block'
        }
      })
    },
    /** 获取dom元素占据空间属性 */
    _getElBoxProperty(el, property) {
      return parseInt(el.getBoundingClientRect()[property])
    },
    /** 重置布局 */
    _resetLayout(formItemEls, formEl) {
      const formWidth = this._getElBoxProperty(formEl, 'width')
      let col = 4
      // let deviceWidth = document.documentElement.clientWidth
      try {
        // if(deviceWidth > 1920) {
        //   col = 4
        // } else if(deviceWidth > 1200) {
        //   col = 3
        // } else if(deviceWidth > 992) {
        //   col = 3
        // } else if(deviceWidth > 768) {
        //   col = 3
        // } else {
        //   col = 3
        // }
        if (formWidth < 663) {
          col = 2
        } else if (formWidth < 1572) {
          col = 3
        } else {
          col = 4
        }
      } catch (e) {
        //TODO handle the exception
      }
      // if (formWidth > 1120 || formWidth == 1120) {
      //   col = 4
      // } else if (formWidth > 840 || formWidth == 840) {
      //   col = 3
      // } else if (formWidth > 560 || formWidth == 560) {
      //   col = 2
      // } else {
      //   col = 1
      // }
      this.curCol = col
      // const widthPercent = parseFloat((1 / col) * 100) + '%'
      this.setIsShowToggle(formItemEls.length, col)
      // console.log('formItemEls', formItemEls)
      Array.from(formItemEls).forEach((item, index) => {
        // item.style.width = widthPercent
        if (this.isCollapse) {
          item.style.display = 'block'
        } else if (index >= col * 1) {
          item.style.display = 'none'
        } else {
          item.style.display = 'block'
        }
      })
    },

    /** 设置是否展示收起与展开按钮 */
    setIsShowToggle(length, col) {
      this.showActionBtn = length > col * 1
    },
    // 抛出重置事件
    reSet() {
      if (this.resetQuery) {
        this.resetQuery()
      } else {
        this.crud.resetQuery()
      }
      this.$emit('reSet')
    },
    // 抛出查询事件
    search() {
      this.crud.toQuery()
      this.$emit('search')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/element-variables.scss";

.eSearch {
  background: #fff;

  // margin-bottom: 10px;
  /deep/.el-card__body {
    padding: 10px 0;
  }

  .formBox {
    display: flex;

    // border: 1px solid #ece9e9;
    // padding-bottom: 10px;
    // border-radius: 6px;
    // padding: 0 20px;
    .el-form {
      flex: 1;
    }

    .boxOperate {
      width: 210px;
      padding: 10px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      img {
        width: 30px;
        height: 20px;
        cursor: pointer;
        margin-right: 20px;
        margin-top: 6px;
      }

      .el-button--mini {
        padding: 8px 16px;
      }
    }
  }

  // 搜索按钮
  .grid-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #ece9e9;

    .fontColor {
      color: $--color-primary;
      margin-left: 20px;
    }

    .bthPosition {
      display: flex;
      justify-content: space-around;
      align-items: center;

      button {
        margin: 0 3px;
      }

      margin-right: 10px;
    }
  }

  // 搜索表单区域
  .formStyle {
    margin-top: 10px;
    // .formItem {
    //   width: 100%;
    //   display:flex;
    //   flex-wrap: wrap;
    //   .el-form-item {
    //     margin: 5px 0!important;
    //     label {
    //       font-weight: 600;
    //       color: #6a6b6d;
    //       font-size: 13px;
    //     }
    //     .el-form-item__content{
    //       .el-input{
    //         width: 180px;
    //       }
    //       .el-select {
    //         width: 180px;
    //       }
    //       .el-checkbox-group {
    //         width: 180px;
    //       }
    //       .vue-treeselect {
    //         width: 180px;
    //         height: 32px;
    //         .vue-treeselect__control {
    //           height: 32px;
    //           .vue-treeselect__value-container {
    //             height: 32px;
    //             .vue-treeselect__input {
    //               height: 32px;
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
  }

  // 下拉按钮
  .showStatus {
    text-align: center;
    color: $--color-primary;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;

    img {
      width: 30;
      height: 20px;
    }
  }
}
</style>
<style scoped>
.formItem>>>.el-col {
  margin-bottom: 10px;
}
</style>
